import { format as formatDate } from 'date-fns/format';
import { isToday } from 'date-fns/isToday';
import { isTomorrow } from 'date-fns/isTomorrow';
import { isYesterday } from 'date-fns/isYesterday';

export const friendlyFormatDate = (dateStr: string | Date) => {
  const date = dateStr instanceof Date ? dateStr : new Date(dateStr);

  if (isYesterday(date.getTime())) {
    return 'Yesterday';
  }

  if (isToday(date.getTime())) {
    return 'Today';
  }

  if (isTomorrow(date.getTime())) {
    return 'Tomorrow';
  }

  const formatted = formatDate(new Date(dateStr), 'd MMM');

  return formatted;
};
